import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ZoneModal } from 'src/app/models/Zone';
import { ReservationService } from 'src/app/services/reservation/reservation.service';

@Component({
  selector: 'app-add-zone-seats',
  templateUrl: './add-zone-seats.component.html',
  styleUrls: ['./add-zone-seats.component.scss']
})
export class AddZoneSeatsComponent {
  @Input() modelId: string;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() routeName: string;
  @Input() clickedBrandId: string;
  @Input() slotType: string;
  @Input() selectedOutlet: number;
  @Input() zoneSeatId: number;
  @Input() zoneSeatDataChanges: string;

  @Output() clearZones = new EventEmitter<any>();
  @Output() clearForms = new EventEmitter<any>();

  submitted: boolean = false
  isSuccess: boolean = false
  loading: boolean = false
  formMessage: string = ''
  fileTypes = ["image/png", "image/jpeg"];
  profilePic: any;
  profileURl: any = '';
  zoneData: ZoneModal;

  constructor(private router: Router, public route: ActivatedRoute, private reservations: ReservationService, private spinner: NgxSpinnerService,) {

  }
  ngOnInit(): void {
    this.spinner.show()
    this.zoneData = this.zoneSeatForm.value
  }

  ngOnChanges() {
    console.log(this.zoneSeatId, this.zoneSeatDataChanges);

    if (this.zoneSeatDataChanges == "changed") {
      this.getZone()
    } else {
      this.clearFormData()
    }
  }

  zoneSeatForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    thumbnail: new FormControl(null,),
    available_online: new FormControl(0, [Validators.required]),
    max_duration: new FormControl('', [Validators.required]),
    slot_type: new FormControl('', [Validators.required]),
    slot_count: new FormControl('', [Validators.required]),
    manual_acceptance_threshold: new FormControl('', [Validators.required]),
    manual_accept: new FormControl(0, [Validators.required]),
    force_deposit: new FormControl(0, [Validators.required]),
    deposit_amount: new FormControl(''),
    deposit_type: new FormControl(''),
    is_refundable: new FormControl(''),
  })

  get setZoneControls() { return this.zoneSeatForm.controls; }

  getZone() {
    console.log(this.zoneSeatId, "this.zoneId");

    this.reservations.getZone(this.zoneSeatId).subscribe({
      next: (res) => {
        console.log(res, "getZone 123")
        this.zoneData = res.data;
        this.profilePic = '';
        if(res.data?.force_deposit != 0){
          this.zoneSeatForm.patchValue(res.data)
        }else{
          this.zoneSeatForm.patchValue(res.data)
          this.zoneSeatForm.patchValue({
            deposit_amount: '',
            deposit_type: '',
            is_refundable: ''
          })
        }
      
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  clearFormData() {
    this.zoneSeatForm.removeControl('name');
    this.zoneSeatForm.removeControl('description');
    this.zoneSeatForm.removeControl('thumbnail');
    this.zoneSeatForm.removeControl('max_duration');
    this.zoneSeatForm.removeControl('slot_type');
    this.zoneSeatForm.removeControl('slot_count');
    this.zoneSeatForm.removeControl('manual_acceptance_threshold');
    this.zoneSeatForm.removeControl('deposit_amount');
    this.zoneSeatForm.removeControl('deposit_type');
    this.zoneSeatForm.removeControl('is_refundable');

    this.zoneSeatForm.addControl('name', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('description', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('thumbnail', new FormControl(null));
    this.zoneSeatForm.addControl('max_duration', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('slot_type', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('slot_count', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('manual_acceptance_threshold', new FormControl('', [Validators.required]));
    this.zoneSeatForm.addControl('deposit_amount', new FormControl(''));
    this.zoneSeatForm.addControl('deposit_type', new FormControl(''));
    this.zoneSeatForm.addControl('is_refundable', new FormControl(''));

    this.zoneSeatForm.patchValue({
      available_online: 0,
      manual_accept: 0,
      force_deposit: 0,
    })
    this.zoneData = this.zoneSeatForm.value
  }

  updateSwitch(type) {
    let value = this.zoneData[type] == 1 ? 0 : 1;
    console.log(value, "updateSwitch");

    if (type == 'available_online') {
      this.zoneSeatForm.patchValue({
        available_online: value
      })
    } else if (type == 'manual_accept') {
      this.zoneSeatForm.patchValue({
        manual_accept: value
      })
    } else if (type == 'force_deposit') {
      this.zoneSeatForm.patchValue({
        force_deposit: value
      })
      if (value == 1) {
        this.zoneSeatForm.controls['deposit_amount'].setValidators(Validators.required);
        this.zoneSeatForm.controls['deposit_type'].setValidators(Validators.required);
        this.zoneSeatForm.controls['is_refundable'].setValidators(Validators.required);
        this.zoneSeatForm.controls['deposit_amount'].updateValueAndValidity()
        this.zoneSeatForm.controls['deposit_type'].updateValueAndValidity()
        this.zoneSeatForm.controls['is_refundable'].updateValueAndValidity()
      } else {
        this.zoneSeatForm.removeControl('deposit_amount');
        this.zoneSeatForm.removeControl('deposit_type');
        this.zoneSeatForm.removeControl('is_refundable');
        this.zoneSeatForm.addControl('deposit_amount', new FormControl(''));
        this.zoneSeatForm.addControl('deposit_type', new FormControl(''));
        this.zoneSeatForm.addControl('is_refundable', new FormControl(''));
      }
    }
  }

  addImage(e: any) {
    let selected = e.target.files[0];
    // console.log(selected,)
    if (selected && this.fileTypes.includes(selected.type)) {
      this.profilePic = selected

      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);

      reader.onload = (_event) => {
        this.profileURl = reader.result;
        this.zoneSeatForm.patchValue({
          thumbnail: selected.name,
        })
      }
    }
  }

  onAddClick() {
    this.submitted = true
    this.loading = true;
    this.zoneSeatForm.patchValue({
      slot_type: this.slotType
    })
    console.log(this.zoneSeatForm, "this.zoneSeatForm.value");

    if (this.zoneSeatForm.invalid) {
      this.loading = false;
      this.isSuccess = false;
      this.formMessage = 'Please fill all required fields!';
    } else {
      let profilePic = this.profilePic ? this.profilePic : ''
      const formData = new FormData();

      formData.append('shop_id', this.selectedOutlet.toString());
      formData.append('name', this.zoneSeatForm.value.name);
      formData.append('description', this.zoneSeatForm.value.description);
      formData.append('thumbnail', profilePic);
      formData.append('available_online', this.zoneSeatForm.value.available_online);
      formData.append('max_duration', this.zoneSeatForm.value.max_duration);
      formData.append('slot_type', this.slotType);
      formData.append('slot_count', this.zoneSeatForm.value.slot_count);
      formData.append('manual_acceptance_threshold', this.zoneSeatForm.value.manual_acceptance_threshold);
      formData.append('manual_accept', this.zoneSeatForm.value.manual_accept);
      formData.append('force_deposit', this.zoneSeatForm.value.force_deposit);
      formData.append('deposit_amount', this.zoneSeatForm.value.deposit_amount);
      formData.append('deposit_type', this.zoneSeatForm.value.deposit_type);
      formData.append('is_refundable', this.zoneSeatForm.value.is_refundable);

      this.reservations.createZone(formData).subscribe({
        next: (res) => {
          console.log(res)
          this.loading = false;
          this.isSuccess = true;
          this.formMessage = 'Contact Page Successfully Added!';
          this.clearZones.emit()
        },
        error: (error) => {
          console.log(error)
          this.loading = false;
          this.isSuccess = false;
          this.formMessage = error;
          this.submitted = false
        }
      })
    }

  }

  onEditClick() {
    this.submitted = true
    this.loading = true;
    this.zoneSeatForm.patchValue({
      slot_type: this.slotType
    })

    if (this.zoneSeatForm.invalid) {
      console.log(this.zoneSeatForm, "this.zoneSeatForm");

      this.loading = false;
      this.isSuccess = false;
      this.formMessage = 'Please fill all required fields!';
    } else {
      let profilePicMedia = this.profilePic
        ? this.profilePic
        : this.zoneSeatForm.value.thumbnail || '';
      const formData = new FormData();

      formData.append('_method', 'PUT');
      formData.append('shop_id', this.selectedOutlet.toString());
      formData.append('name', this.zoneSeatForm.value.name);
      formData.append('description', this.zoneSeatForm.value.description);
      formData.append('thumbnail', profilePicMedia);
      formData.append('available_online', this.zoneSeatForm.value.available_online);
      formData.append('max_duration', this.zoneSeatForm.value.max_duration);
      formData.append('slot_type', this.slotType);
      formData.append('slot_count', this.zoneSeatForm.value.slot_count);
      formData.append('manual_acceptance_threshold', this.zoneSeatForm.value.manual_acceptance_threshold);
      formData.append('manual_accept', this.zoneSeatForm.value.manual_accept);
      formData.append('force_deposit', this.zoneSeatForm.value.force_deposit);
      formData.append('deposit_amount', this.zoneSeatForm.value.deposit_amount);
      formData.append('deposit_type', this.zoneSeatForm.value.deposit_type);
      formData.append('is_refundable', this.zoneSeatForm.value.is_refundable);

      this.reservations.updateZone(this.zoneSeatId, formData).subscribe({
        next: (res) => {
          console.log(res)
          this.loading = false;
          this.isSuccess = true;
          this.formMessage = 'Contact Page Successfully Updated!';
          this.clearZones.emit()
        },
        error: (error) => {
          console.log(error)
          this.loading = false;
          this.isSuccess = false;
          this.formMessage = error;
          this.submitted = false
        }
      })
    }
  }

  onCancelClick() {
    this.clearForms.emit()
    this.submitted = false
    this.zoneSeatForm.get('name').clearValidators();
    this.zoneSeatForm.get('name').updateValueAndValidity();
    this.zoneSeatForm.get('description').clearValidators();
    this.zoneSeatForm.get('description').updateValueAndValidity();
    this.zoneSeatForm.get('available_online').clearValidators();
    this.zoneSeatForm.get('available_online').updateValueAndValidity();
    this.zoneSeatForm.get('max_duration').clearValidators();
    this.zoneSeatForm.get('max_duration').updateValueAndValidity();
    this.zoneSeatForm.get('slot_type').clearValidators();
    this.zoneSeatForm.get('slot_type').updateValueAndValidity();
    this.zoneSeatForm.get('slot_count').clearValidators();
    this.zoneSeatForm.get('slot_count').updateValueAndValidity();
    this.zoneSeatForm.get('manual_acceptance_threshold').clearValidators();
    this.zoneSeatForm.get('manual_acceptance_threshold').updateValueAndValidity();
    this.zoneSeatForm.get('manual_accept').clearValidators();
    this.zoneSeatForm.get('manual_accept').updateValueAndValidity();
    this.zoneSeatForm.get('force_deposit').clearValidators();
    this.zoneSeatForm.get('force_deposit').updateValueAndValidity();
    this.zoneSeatForm.get('deposit_amount').clearValidators();
    this.zoneSeatForm.get('deposit_amount').updateValueAndValidity();
    this.zoneSeatForm.get('deposit_type').clearValidators();
    this.zoneSeatForm.get('deposit_type').updateValueAndValidity();
    this.zoneSeatForm.get('is_refundable').clearValidators();
    this.clearFormData()
  }
}
